import { render } from "./account-dropdown.vue?vue&type=template&id=207ffc87&scoped=true&ts=true"
import script from "./account-dropdown.vue?vue&type=script&lang=ts"
export * from "./account-dropdown.vue?vue&type=script&lang=ts"

import "./account-dropdown.vue?vue&type=style&index=0&id=207ffc87&lang=scss&scoped=true"
import "./account-dropdown.vue?vue&type=style&index=1&id=207ffc87&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-207ffc87"]])

export default __exports__